(function () {
  function sync(form) {
    var property = form && form.querySelector('[data-hm-preorder-property]');
    if (!property) return;
    var variant = form.querySelector('[name="id"]');
    property.disabled = !variant || property.dataset.hmPreorderVariants.indexOf(',' + variant.value + ',') === -1;
  }
  function syncAll() {
    document.querySelectorAll('[data-hm-preorder-property]').forEach(function (property) { sync(property.form); });
  }
  document.addEventListener('change', function (event) { sync(event.target.form); }, true);
  document.addEventListener('submit', function (event) { sync(event.target); }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action-atc]');
    if (!button || !button.closest('[data-sticky-addtocart]')) return;
    var form = Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"]')).find(function (candidate) {
      var variant = candidate.querySelector('[name="id"]');
      return variant && variant.value === button.dataset.variantId && candidate.querySelector('[data-hm-preorder-property]');
    });
    if (!form) return;
    sync(form);
    var property = form.querySelector('[data-hm-preorder-property]');
    if (property.disabled) return;
    var submit = form.querySelector('button[name="add"]');
    if (!submit || submit.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var stickyQuantity = button.closest('[data-sticky-addtocart]').querySelector('[data-quantity-value]');
    var quantity = form.querySelector('[name="quantity"]');
    if (stickyQuantity && quantity) quantity.value = stickyQuantity.value;
    form.requestSubmit(submit);
  }, true);
  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; syncAll(); });
  });
  function init() {
    syncAll();
    observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'selected']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
